<template>
  <div class="app-radio-box">
    <h3
      v-if="label"
      :class="{ 'required-field': isRequired }"
    >
      {{ label }}<span v-if="onRequired">{{'*'}}</span>
    </h3>
    <v-radio-group
      :value="value"
      :row="row"
      :disabled="disabled"
      :persistent-hint="persistentHint"
      :hint="hint"
      :error-messages="$formErrors(v)"
      @change="change"
      class="mb-0"
    >
      <v-radio
        v-for="(option, index) in options"
        :key="index"
        :label="option[onLabel]"
        :value="option[onValue]"
        :disabled="option.disabled"
        color="secondary"
      />
    </v-radio-group>
  </div>
</template>

<script>
export default {
  name: 'AppRadioBox',
  props: {
    value: {
      type: [String, Number, Boolean],
      default: null
    },
    label: {
      type: String,
      default: ''
    },
    hint: {
      type: String,
      default: ''
    },
    onRequired: {
      type: Boolean,
      default: () => false
    },
    persistentHint: {
      type: Boolean,
      default: () => false
    },
    onLabel: {
      type: String,
      default: () => 'title'
    },
    onValue: {
      type: String,
      default: () => 'value'
    },
    options: {
      type: Array,
      default: () => []
    },
    row: {
      type: Boolean,
      default: () => false
    },
    v: { type: Object, default: () => {} },
    disabled: {
      type: Boolean,
      default: () => false
    }
  },
  computed: {
    isRequired() {
      return this.v ? this.v.hasOwnProperty('required') : false
    }
  },
  methods: {
    change(value) {
      if (this.v) this.v.$touch()

      this.$emit('input', value)
      this.$emit('change', value)
    },
    input(value) {
      if (this.v) this.v.$touch()
      this.$emit('input', value)
    },
    clear() {
      this.$emit('clear', { name: this.$attrs.name })
    }
  }
}
</script>

<style lang="stylus" scoped>
  .app-radio-box
    h3
      color rgba(0,0,0,.6)
      font-weight normal
      font-size 12px
      margin-bottom -10px
      span
        color #ff5252
        margin-left 3px
</style>
